import { render, staticRenderFns } from "./TotalEffluent.vue?vue&type=template&id=4c9b6ff0&scoped=true&"
import script from "./TotalEffluent.vue?vue&type=script&lang=js&"
export * from "./TotalEffluent.vue?vue&type=script&lang=js&"
import style0 from "./TotalEffluent.vue?vue&type=style&index=0&id=4c9b6ff0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9b6ff0",
  null
  
)

export default component.exports